import { Store } from "../contexts/Store";

export default function useCheckout () {
  const { checkout } = Store.useState(s => s);

  const hasInBasket = listingId => checkout.items.find(i => i.listing.id === listingId);

  return { hasInBasket };
}
